import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './CustomRequestForm.css';

const CustomRequestForm = ({
  planTitle,
  features,
  originalPrice,
  discountPrice,
  formFields,
  serviceId,
  templateId,
  publicKey,
  successMessage,
  returnLink,
  buttonText = 'Anfrage senden',
  voucherType,
  budget
}) => {
  const formRef = useRef(null);
  const textareaRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const autoResizeTextarea = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');

    emailjs
      .sendForm(
        serviceId,
        templateId,
        formRef.current,
        publicKey
      )
      .then(
        (result) => {
          console.log("SUCCESS!", result.status, result.text);
          setSubmitted(true);
        },
        (error) => {
          console.error("FAILED...", error);
          setErrorMessage('Beim Versenden Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.');
        }
      );
  };

  if (submitted) {
    return (
      <div className="custom-request-success">
        <h3>Vielen Dank für Ihre Anfrage!</h3>
        <p>{successMessage}</p>
        <a href={returnLink} className="return-button">
          Zurück zur Übersicht
        </a>
      </div>
    );
  }

  return (
    <section className="custom-request-section">
      <div className="custom-request-container">
        <div className="custom-request-header">
          <h2>{planTitle}</h2>
          <div className="custom-request-pricing">
            {originalPrice && (
              <div className="price-discount">
                <span className="custom-original-price">€{originalPrice}</span>
                <span className="discount-badge">
                  {Math.round(((originalPrice - discountPrice) / originalPrice) * 100)}% Rabatt
                </span>
              </div>
            )}
            <div className="custom-current-price">
              {typeof discountPrice === 'number' ? `€${discountPrice}` : discountPrice}
            </div>
          </div>
        </div>

        <div className="custom-request-content">
          <div className="custom-request-details">
            <h3>Enthaltene Leistungen:</h3>
            <ul className="feature-list">
              {features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>

          <form ref={formRef} className="custom-request-form" onSubmit={handleSubmit}>
            {formFields.map((field) => (
              <div className="form-group" key={field.name}>
                <label htmlFor={field.name}>{field.label}</label>
                {field.type === 'textarea' ? (
                  <textarea
                    ref={textareaRef}
                    id={field.name}
                    name={field.name}
                    required={field.required}
                    placeholder={field.placeholder}
                    onInput={autoResizeTextarea}
                    rows="4"
                  />
                ) : (
                  <input
                    type={field.type}
                    id={field.name}
                    name={field.name}
                    required={field.required}
                    placeholder={field.placeholder}
                  />
                )}
              </div>
            ))}

            {errorMessage && <div className="error-message">{errorMessage}</div>}

            <input type="hidden" name="dienstleistung" value="Web Entwicklung" />
            <input type="hidden" name="budget" value={budget} />
            <input type="hidden" name="voucherType" value={voucherType} />

            <button type="submit" className="submit-button">
              {buttonText}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

// Keep the same propTypes as before

export default CustomRequestForm;